import React from "react";
import { PageHeader } from "../../../components";

export default function SPORTSSECRETARY() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_SPORTS SECETERARY.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">MR. OLUSEYE OLASOGBA</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                    16yrs Banking Experience (Chartered Bank, FSB International,
                    Intercontinental Bank & Access Bank); 4yrs FMCG experience
                    (ALMA Stores P&G, Nigerian Breweries, Guiness Nigeria &
                    Wampco Distribution). Entrepreneur / Business owner - Ennovy
                    Integrated Services Ltd. (Recycling)
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
